import { Box, ButtonIcon, Icon, Typography } from "@saviynt/design-system";
import { useIntl } from "react-intl";

export function AccordionHeader({
  title,
  isExpanded,
  onToggle,
}: {
  title: string | React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
}) {
  const intl = useIntl();
  return (
    <Box className="policies-accordion-header">
      <Box className="policies-accordion-header-text-section">
        {typeof title === "string" ? (
          <Typography
            kind="body2"
            desktop="body2-m"
            mobile="body2-m"
            color="--color-foreground-secondary-bold"
            className="policies-accordion-header-text-subtitle"
            lineLimit={1}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
      </Box>
      <Box className="policies-accordion-header-trailing-control-area">
        <ButtonIcon
          size="small"
          kind="ghost"
          icon={
            <Icon
              kind={isExpanded ? "ChevronUp" : "ChevronDown"}
              size="medium"
            />
          }
          ariaLabel={intl.formatMessage({
            defaultMessage: "Accordion toggle button",
            id: "FJDSje",
            description: "Aria label for Accordion toggle button",
          })}
          onClick={onToggle}
        />
      </Box>
    </Box>
  );
}
